var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnpin = function SvgUnpin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A1629",
    d: "M10.73 1.59a2 2 0 0 0-2.56-.23 2 2 0 0 0-.61.69l-2 3.76-3.14 1.24a.7.7 0 0 0-.41.81.7.7 0 0 0 .16.28l2.2 2.2-2.84 2.86a.82.82 0 0 0 .94.94l2.86-2.86 2.2 2.19a.64.64 0 0 0 .6.18.6.6 0 0 0 .29-.14.7.7 0 0 0 .2-.26l1.24-3.11 3.76-2a2 2 0 0 0 .69-.62 2.2 2.2 0 0 0 .34-.85c.042-.31.011-.624-.09-.92a1.9 1.9 0 0 0-.48-.79zm-2 1.09a.66.66 0 0 1 .21-.23.7.7 0 0 1 .28-.11.65.65 0 0 1 .31 0c.1.027.19.083.26.16l3.35 3.35a.6.6 0 0 1 .16.26.77.77 0 0 1-.12.59.64.64 0 0 1-.23.2L9 9.08a.76.76 0 0 0-.3.34l-1 2.39-3.9-3.9L6.24 7a.63.63 0 0 0 .34-.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A1629",
    d: "M9.52 1.81 7.4 3.22l-.9 2.35-1.65 1.5-2.15.51 4.47 4.5.83.54 1.99-3.3 3.96-2.55.3-.97z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0A1629",
    strokeLinecap: "round",
    d: "m2 2 11.314 11.314"
  })));
};
export default SvgUnpin;